module.exports = __webpack_public_path__ + "img/bg.186109cc.jpg";